import { render, staticRenderFns } from "./StarRatingConfigForm.vue?vue&type=template&id=d99e6fbc&scoped=true&"
import script from "./StarRatingConfigForm.vue?vue&type=script&lang=js&"
export * from "./StarRatingConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./StarRatingConfigForm.vue?vue&type=style&index=0&id=d99e6fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99e6fbc",
  null
  
)

export default component.exports